import { useState, useEffect, useMemo, useCallback } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";

import { AddCircle, CheckBox, CheckBoxOutlineBlank, CheckCircle, Delete, Layers, Style as StyleIcon } from "@mui/icons-material";
// import StyleIcon from '@mui/icons-material/';
// import SearchBox from "../../components/SearchBox";
import MembersList, { MemberSortField } from "../../components/MembersList";
import { SortDirection } from "../../components/SortableHeader";
import { SetExpirationModal } from "../../molecules/AppModal";
import { useMemberState } from "../../contexts/membercontext";
// import { useResourceState } from "../../contexts/kitchencontext";
// import {useLoadCommunity} from "../../hooks/authhooks"; 
import { useLoadMemberships, useLoadRequests } from "../../hooks/memberhooks";
import { useLoadRequirements, useResourceHook, useLoadCommunityResourcesOnly } from "../../hooks/resourcehooks";
import { useLoadPlans, useTeamAccess } from "../../hooks/communityhook";
import { canAccess } from "../../utils/teamPermissions";
import EditMultipleMembers from '../../molecules/EditMultipleMembers'
import NewSearch from "../../molecules/NewSearch";
import { ReactComponent as KitchenIcon } from '../../icons/KitchenIcon.svg'
import { CommunityOptionType, InventorySchema, PlanInventorySelection, PlanSchema, RequirementSchema, RequirementsLookupSchema, ResourceSchema } from "../../data/types";
// import { AddCircle } from "@mui/icons-material";
import { capitalizeString, styleThousandCommas, memberCountPerPlan, areArraysEqualByProps, filterMemberships, getDefaultMemberSortDirection, sortMemberships, planShowsFulltimeHoursBadge } from "../../utils/helpers";
import { requirementsLookUp } from "../../utils/enums";

import { useAuthState } from '../../contexts/authcontext'
// import { ReactComponent as ClockIcon } from '../../icons/ClockIcon.svg'
import { ReactComponent as ClockIcon } from '../../icons/ClockIcon.svg'
import { ReactComponent as PlanIcon } from '../../icons/PlanIcon.svg'
import { ReactComponent as CopyIcon } from '../../icons/CopyIcon.svg'
import { ReactComponent as DeleteIcon } from '../../icons/DeleteIcon.svg'
import { ReactComponent as EditIcon } from '../../icons/EditIcon.svg'
// import { ReactComponent as AddImageIcon } from '../../icons/AddImageIcon.svg'
// import { CustomAddImageBox } from '../../components/AddImageBox'
// import { CommunityRequirementsForm } from "../../molecules/forms";
import { AllMemberRequests } from "./RequestsPage";
import MemberAgreement from "./MemberAgreement";
import { AddPlanModal, AddRequirementModal, DeleteConfirmationModal, EditPlanModal } from "../../molecules/AppModal";
import LoadingScreen from "../shared/LoadingScreen";
import { toast } from "sonner";
import { getResourceInventoryItems } from "../../molecules/forms/PlanTierResourceFeatures";
// import FocusGroupInsightsPage from "../focus-groups/FocusGroupInsightsPage";





const Memberships = () => {

  var { authUser } = useAuthState()
  var communityId = (authUser && authUser.primary_community) ? authUser.primary_community : ""
  // var { primaryCommunity } = useLoadCommunity(communityId)

  var { memberships } = useLoadMemberships();
  const { membershipRequests, addingMembers, setAddingMembers } = useMemberState();
  // const [currentOption, setCurrentOption] = useState<CommunityOptionType>({id: "details", name: "Community Details"});

  const closeAppModal = () => {
    setAddingMembers(false)
  };

  // const communityOptions = [
  //   {
  //     id: "details",
  //     name: "Community Details"
  //   },
  //   {
  //     id: "images",
  //     name: "Logo and Images"
  //   },
  //   {
  //     id: "plans",
  //     name: "Plans"
  //   },
  //   {
  //     id: "requirements",
  //     name: "Requirements"
  //   },
  //   {
  //     id: "memberships",
  //     name: "Memberships"
  //   },
  //   {
  //     id: "reviews",
  //     name: "Reviews"
  //   },
  //   {
  //     id: "focus-groups",
  //     name: "Focus Groups"
  //   }
  // ]


  // const [currentCommunity, setCurrentCommunity] = useState<DSCommunitySchema>(primaryCommunity as DSCommunitySchema)
  // const [isOpenPlan, setIsOpenPlan] = useState<boolean>(false);
  // const { memberships } = useLoadMemberships();
  // const { membershipRequests } = useLoadRequests();

  // const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
  //   const { name, value } = e.target
  //   if (name && (value || value === "")){
  //     setCurrentCommunity(prev => (
  //       {
  //         ...prev,
  //         [name]: value
  //       }
  //     ))
  //   }
  // }

  useEffect(() => {
    document.title = `HomeCook | Memberships`;
    // eslint-disable-next-line
  }, [memberships, membershipRequests]);

  return addingMembers ? (
    <div className="md:p-[3%] w-full bg-back-400 pt-16 md:pt-16 font-open-sans flex flex-col gap-10">
      <div>
        <h1 className="text-3xl font-bold text-center justify-self-center">Add New Member Details</h1>
        <h1 className="text-md text-center justify-self-center">Include plans & other membership details for new members.</h1>
      </div>
      <EditMultipleMembers closeAppModal={closeAppModal} cancelEditMember={() => setAddingMembers(false)}/>
    </div>
  ) : (
    <div className="page-canvas h-auto">

      <MembershipPage communityId={communityId} />

    </div>
  );
};




type MembershipProps = {
  communityId: string
}

const getInitialMembershipOption = (
  pathname: string,
  view: string | null,
  options: CommunityOptionType[]
): CommunityOptionType => {
  const agreementOption = options.find((option) => option.id === "agreement") ?? options[0];
  const viewOption = view ? options.find((option) => option.id === view) : undefined;

  if (pathname === "/memberships/agreement") {
    return agreementOption;
  }

  if (viewOption) {
    return viewOption;
  }

  return agreementOption;
};

const membershipTabRequiresRequests = (optionId: string) => optionId === "requests";

const MembershipPage: React.FC<MembershipProps> = ({communityId}) => {
  const { permissions } = useTeamAccess();
  const canManageMembers = canAccess(permissions, "manageMembers");
  const canManageRequests = canAccess(permissions, "manageRequests");

  const membershipOptions = [
    {
      id: "agreement",
      name: "Membership Agreement",
    },
    {
      id: "members",
      name: "Approved Members",
    },
    {
      id: "requests",
      name: "Pending Requests",
    },
    {
      id: "plans",
      name: "Membership Tiers",
    },
    {
      id: "requirements",
      name: "Credential Requirements",
    },
  ].filter((option) =>
    membershipTabRequiresRequests(option.id) ? canManageRequests : canManageMembers
  )

  const location = useLocation()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const isAgreementPath = location.pathname === "/memberships/agreement"
  // const agreementOption = membershipOptions.find((o) => o.id === "agreement") ?? membershipOptions[0]
  const [currentOption, setCurrentOption] = useState<CommunityOptionType>(() =>
    getInitialMembershipOption(
      location.pathname,
      searchParams.get("view"),
      membershipOptions
    )
  )
  const [isOpenPlan, setIsOpenPlan] = useState<boolean>(false);
  const [isDuplicate, setIsDuplicate] = useState<{existingPlan: PlanSchema, checked: boolean}>({existingPlan: {} as PlanSchema, checked: false});
  const { memberships } = useLoadMemberships();
  const { membershipRequests } = useLoadRequests();
  const [editPlanId, setEditPlanId] = useState<string | null>(null);
  const allMemberships = [...(memberships || []), ...(membershipRequests || [])]
  const membershipsPerPlan = memberCountPerPlan(allMemberships)
  const { plans, updateCommunityPlan } = useLoadPlans()
  const editPlan = useMemo(
    () => (editPlanId ? plans?.find((plan) => plan.plan_id === editPlanId) : undefined),
    [editPlanId, plans]
  );

  useEffect(() => {
    document.title = "HomeCook | Memberships";
  }, []);

  useEffect(() => {
    const nextOption = getInitialMembershipOption(
      location.pathname,
      searchParams.get("view"),
      membershipOptions
    );
    setCurrentOption(
      membershipOptions.some((option) => option.id === nextOption.id)
        ? nextOption
        : membershipOptions[0]
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps -- sync tab when route or view changes
  }, [isAgreementPath, searchParams, canManageMembers, canManageRequests])

  const handleOptionClick = (option: CommunityOptionType) => {
    setCurrentOption(option)
    if (option.id === "agreement") {
      navigate("/memberships/agreement")
    } else {
      navigate(`/memberships?view=${option.id}`)
    }
  }

  const handleEditPlan = async (planId: string, plan: PlanSchema) => {
    const updatedPlan = await updateCommunityPlan(planId, plan)
    if (updatedPlan){
      toast.success("Plan edited successfully!")
    } else {
      toast.error("Error editing plan. Please try again.")
    }
    setEditPlanId(null)
  }

  return (
    <>
      <div className="flex flex-row flex-nowrap items-center overflow-x-auto bg-white h-[75px] w-full my-1">
        {
          membershipOptions.map((membershipOption: CommunityOptionType, i: number) => {
            return (
              <div 
                key={i} 
                onClick={()=> handleOptionClick(membershipOption)} 
                className={`${(currentOption.id === membershipOption.id) ? 'text-white bg-primary-200 font-medium' : 'text-[#4D4D4D] '} ml-6 my-auto text-[16px] font-raleway border-[1px] border-[#E9E9E9] py-2 px-4 rounded-md cursor-pointer shrink-0`}
              >
                  {membershipOption.name}&nbsp;
                  {
                    (memberships && (membershipOption.id === "members")) && `(${memberships?.length})`
                  }
                  {
                    (membershipRequests && (membershipOption.id === "requests")) && `(${membershipRequests?.length})`
                  }
              </div>
            )
          })
        }
      </div>
      {
        (currentOption.id === "members") ? (
          <AllMembers 
            memberships={memberships} 
          />
        ) : (
          (currentOption.id === "plans") ? (
            <MemberPlans 
              membershipsPerPlan={membershipsPerPlan} 
              setIsDuplicate={setIsDuplicate} 
              openAddModal={()=> setIsOpenPlan(true)} 
              openDuplicateModal={(existingPlan: PlanSchema)=> setIsDuplicate({existingPlan, checked: true})} 
              openEditPlanModal={(existingPlan: PlanSchema)=> setEditPlanId(existingPlan.plan_id ?? null)}
            />
          ) : (
            (currentOption.id === "requirements") ? (
              <CommunityRequirementsForm 
                communityId={communityId} 
              />
            ) : (
              (currentOption.id === "agreement") ? (
                <MemberAgreement communityId={communityId} />
              ) : (
                <AllMemberRequests 
                  membershipRequests={membershipRequests || []} 
                />
              )
            )
          )
        )
      }
      <AddPlanModal
        isOpen={isOpenPlan || isDuplicate.checked}
        isDuplicate={isDuplicate}
        closeAppModal={() => {
          setIsOpenPlan(false)
          setIsDuplicate({existingPlan: {} as PlanSchema, checked: false})
        }}
      />
      <EditPlanModal
        isOpen={!!editPlanId}
        closeAppModal={() => setEditPlanId(null)}
        existingPlan={editPlan ?? ({} as PlanSchema)}
        handleEditPlan={handleEditPlan}
      />
  </>
  )
}


export const AllMembers: React.FC<{memberships: any}> = ({memberships}) => {
  
  const [ searchTerm, changeSearchTerm] = useState("")
  const [currentPage, setCurrentPage] = useState(1)
  const [sortField, setSortField] = useState<MemberSortField>('joined')
  const [sortDirection, setSortDirection] = useState<SortDirection>('desc')

  const kitchen_capacity =  1
  const itemsPerPage = 10

  const allMembers = memberships ?? []

  const filteredMembers = useMemo(
    () => filterMemberships(memberships ?? [], searchTerm),
    [memberships, searchTerm]
  )

  const displayMembers = useMemo(
    () => sortMemberships(filteredMembers, sortField, sortDirection),
    [filteredMembers, sortField, sortDirection]
  )

  const totalPages = Math.ceil(displayMembers.length / itemsPerPage)
  const startIndex = displayMembers.length > 0 ? (currentPage - 1) * itemsPerPage : 0
  const endIndex = Math.min(startIndex + itemsPerPage, displayMembers.length)
  const currentMembers = displayMembers.slice(startIndex, endIndex)

  const handlePageChange = (page: number) => {
    setCurrentPage(page)
  }

  const handleSort = useCallback((field: MemberSortField) => {
    if (field === sortField) {
      setSortDirection((prev) => (prev === 'asc' ? 'desc' : 'asc'))
      return
    }

    setSortField(field)
    setSortDirection(getDefaultMemberSortDirection(field))
  }, [sortField])

  useEffect(() => {
    setCurrentPage(1)
  }, [searchTerm, sortField, sortDirection])

  useEffect(() => {
    if (totalPages > 0 && currentPage > totalPages) {
      setCurrentPage(totalPages)
    }
  }, [currentPage, totalPages])

  useEffect(() => {
    document.title = "HomeCook | Members";
  }, [memberships]);

  const hasSearchFilter = searchTerm.trim().length > 0

  return (
    <div className="w-full min-w-0 px-6">
    <div data-testid="members-table-card" className="flex flex-col w-full min-w-0 bg-white my-6 rounded-xl min-h-[777px] shadow-md">
      <div className="flex flex-row w-full min-w-0 justify-between items-center gap-4 px-6 pt-6">
      <p className=" font-raleway text-[#8A8A8A] text-[14px] shrink-0" >
          {allMembers.length > 0 ? (
            displayMembers.length > 0
              ? `Showing ${startIndex + 1} - ${endIndex} of ${displayMembers.length} Members`
              : "Showing 0 - 0 of 0 Members"
          ) : (
            "Showing 0 - 0 of 0 Members"
          )}
        </p>

        <div className="flex ml-auto w-full max-w-xs min-w-0">
          <NewSearch searchType="member name" searchTerm={searchTerm} changeSearchTerm={changeSearchTerm} />
        </div>
        
      </div>

      <div className="w-full min-w-0 px-6 pb-6">
        {
          allMembers.length > 0 ? (
            <MembersList
              kitchen_capacity={kitchen_capacity}
              members={displayMembers}
              currentPage={currentPage}
              currentMembers={currentMembers}
              totalPages={totalPages}
              itemsPerPage={itemsPerPage}
              handlePageChange={handlePageChange}
              sortField={sortField}
              sortDirection={sortDirection}
              onSort={handleSort}
              hasSearchFilter={hasSearchFilter}
            />
          ) : (
            <div className="flex flex-row font-open-sans justify-evenly font-light text-center text-sm text-[#013847]/40 ">
              No members to show yet
            </div>
          )
        }
      </div>
      
    </div>
    </div>
  )
}


type MemberPlansProps = {
  membershipsPerPlan: { [key: string]: number }
  setIsDuplicate: React.Dispatch<React.SetStateAction<{existingPlan: PlanSchema, checked: boolean}>>
  openAddModal: ()=> void
  openDuplicateModal: (plan: PlanSchema)=> void
  openEditPlanModal: (existingPlan: PlanSchema)=> void
}

/** Builds a lookup map of inventory items by id for tier feature labels */
const buildInventoryItemsById = (resources?: ResourceSchema[]): Map<string, InventorySchema> => {
  const map = new Map<string, InventorySchema>();

  (resources || []).forEach((resource) => {
    getResourceInventoryItems(resource).forEach((item) => {
      if (item.id) {
        map.set(item.id, item);
      }
    });
  });

  return map;
};

/** Resolves the display label for a linked inventory selection on a tier */
const getInventorySelectionLabel = (
  selection: PlanInventorySelection,
  inventoryItemsById: Map<string, InventorySchema>
): string => {
  const item = inventoryItemsById.get(selection.inventory_id);
  return item?.item_name?.trim() || "Inventory item";
};

/** Whether a plan has perks, linked resources, or inventory items to show under Tier Features */
const planHasTierFeatures = (plan: PlanSchema): boolean => {
  const hasFeatures = (plan.features?.length ?? 0) > 0;
  const hasResources = (plan.associated_resources?.length ?? 0) > 0;
  const hasInventory = (plan.associated_resources || []).some(
    (association) => (association.inventory?.length ?? 0) > 0
  );
  return hasFeatures || hasResources || hasInventory;
};

const MemberPlans: React.FC<MemberPlansProps> = ({openEditPlanModal, openAddModal, openDuplicateModal, membershipsPerPlan}) => {
  const { authUser } = useAuthState()
  const communityId = (authUser && authUser.primary_community) ? authUser.primary_community : ""
  const {plans } = useLoadPlans()
  const { resources } = useLoadCommunityResourcesOnly(communityId)
  const inventoryItemsById = useMemo(
    () => buildInventoryItemsById(resources),
    [resources]
  )
  const { deletePlan } = useResourceHook({})
  type DeletePlanType = {status: boolean, plan: PlanSchema}
  const [isDeleting, setIsDeleting] = useState<DeletePlanType>({status: false, plan: {} as PlanSchema})
  const handleDelete = (planId: string) => {
    if (planId){
      deletePlan(planId, "membership")
    }
    setIsDeleting({status: false, plan: {} as PlanSchema})
  }

  useEffect(() => {
    document.title = "HomeCook | Community Plans";
  }, [plans]);

  return (
    (plans && plans.length > 0 ) ? (
      <>
        <div className="flex flex-row mx-auto w-full px-6">
          <button 
            className="bg-primary-200 text-[16px] font-raleway text-white px-3 py-2 rounded-md mt-2 mx-2 w-auto  ml-auto"
            onClick={openAddModal}
          >
            <AddCircle className="my-auto mx-2 text-white" style={{height: 20, width: 20}} />
            Add Membership Tier
          </button>
        </div>
        <div className="grid grid-cols-2 grid-flow-dense w-full px-6 mx-auto">
          {
            plans.map((plan: PlanSchema, i: number) => (
              <div key={i} className="flex flex-col h-[450px] bg-white mx-2 my-4 rounded-lg">
                <div className="m-[24px] text-black font-raleway text-[20px] font-medium">
                  <div className="flex flex-row flex-wrap items-center gap-x-2 gap-y-1">
                    <span>{plan.plan_name}</span>
                    {planShowsFulltimeHoursBadge(plan, { defaultPlanType: "membership" }) && (
                      <span className="flex flex-row items-center text-[#0F766E] bg-[#ECFDF5] font-medium text-[13px] font-raleway rounded-2xl px-3 py-1">
                        <ClockIcon className="my-auto mr-1 shrink-0" style={{ height: 14, width: 14 }} />
                        24/7 Access
                      </span>
                    )}
                    <span className="text-[#808080] my-auto text-[13px] font-raleway">({membershipsPerPlan[plan.plan_id || ""] || 0} Members)</span>
                    <span onClick={()=> openDuplicateModal(plan)} className="flex flex-row ml-auto text-[#808080]/50 my-auto text-[13px] font-raleway cursor-pointer">
                      <CopyIcon className="my-auto mr-1 " style={{height: 16, width: 16}} /> Duplicate Tier
                    </span>
                  </div>
                  {
                    (plan.plan_description && plan.plan_description.length > 0) && (
                      <p className="text-[#4D4D4D]/70 text-[14px] font-normal font-open-sans mt-1">{capitalizeString(plan.plan_description)}</p>
                    )
                  }
                </div>
                <hr className="border-[#E9E9E9] b-0 border-b-[1px]" />
                <div className="flex flex-row m-[24px] gap-x-2">
                  <div className="flex flex-col bg-[#FAFAFA] rounded-md p-4 w-1/2">
                    <p className="flex flex-row text-[#808080] text-[14px] font-medium font-raleway"><PlanIcon className="my-auto mr-1 text-primary-400" style={{height: 16, width: 16}} /> Tier Rate</p>
                    <p className="text-[18px] font-raleway font-semibold text-black">${styleThousandCommas(plan.plan_rate || 0)}</p>
                  </div>
                  {/* <div className="w-[2px] h-[32px] bg-[#E9E9E9] mx-auto" /> */}
                  <div className="flex flex-col bg-[#FAFAFA] rounded-md p-4 w-1/2">
                    <p className="flex flex-row text-[#808080] text-[14px] font-medium font-raleway"><StyleIcon className="my-auto mr-1 text-primary-400" style={{height: 16, width: 16}} /> Tier Type</p>
                    <p className="text-[18px] font-raleway font-semibold text-black">{capitalizeString((plan && plan?.plan_recurrence) ? plan.plan_recurrence : "N/A")}</p>
                  </div>
                  {/* <div className="w-[2px] h-[32px] bg-[#E9E9E9] mx-auto" /> */}
                  {/* <div className="flex flex-col bg-[#FAFAFA]  rounded-md p-4 w-1/3">
                    <p className="flex flex-row text-[#808080] text-[14px] font-medium font-raleway"><ClockIcon className="my-auto mr-1 text-primary-400" style={{height: 16, width: 16}} /> Max Hours</p>
                    <p className="text-[18px] font-raleway font-semibold text-black">{plan.plan_max_hours}</p>
                  </div> */}

                  {/* <div className="w-[2px] h-[32px] bg-[#E9E9E9] mx-auto" />
                  <div className="flex flex-col">
                    <p className="text-[#808080] text-[16px] font-raleway">Capacity</p>
                    <p className="text-[16px] font-open-sans">0 Members</p>
                  </div> */}

                </div> 
                <div className="flex flex-col mx-[24px] flex-1 min-h-0 overflow-y-auto pb-2">
                  <p className="text-[#808080] text-[14px] mb-1 font-medium font-raleway">Tier Features</p>
                  {
                    planHasTierFeatures(plan) ? (
                      <>
                        {plan.features && plan.features.map((feature: string, i: number) => (
                          <p key={`feature-${i}`} className="flex flex-row text-[16px] font-open-sans font-normal text-black"> <CheckCircle className="my-auto mr-1 text-primary-400 shrink-0" style={{height: 16, width: 16}} /> {feature}</p>
                        ))}
                        {plan.associated_resources && plan.associated_resources.map((association, i: number) => (
                          <div key={`resource-${i}`} className="flex flex-col">
                            <p className="flex flex-row items-center text-[16px] font-open-sans font-normal text-black">
                              <Layers className="my-auto mr-1 text-primary-400 shrink-0" style={{height: 16, width: 16}} />
                              <span className="truncate">{association.resource_name || "Linked resource"}</span>
                            </p>
                            {association.inventory?.map((selection, inventoryIndex: number) => (
                              <p
                                key={`resource-${i}-inventory-${selection.inventory_id}-${inventoryIndex}`}
                                className="flex flex-row items-center text-[15px] font-open-sans font-normal text-black ml-5"
                              >
                                <KitchenIcon className="my-auto mr-1 text-primary-400 shrink-0" style={{height: 14, width: 14}} />
                                <span className="truncate">{getInventorySelectionLabel(selection, inventoryItemsById)}</span>
                                {selection.max_qty > 0 && (
                                  <span className="text-[#808080] text-[13px] ml-1 shrink-0">
                                    · max {selection.max_qty}
                                  </span>
                                )}
                              </p>
                            ))}
                          </div>
                        ))}
                      </>
                    ) : (
                      <p className="flex flex-row text-[16px] font-open-sans font-normal text-black"> No features yet</p>
                    )
                  }

                </div>
                <div className="flex w-full mt-auto bg-primary-200 text-white h-[75px] font-raleway rounded-b-lg">
                  <button 
                    className="flex flex-row mr-auto my-auto mx-[24px] font-medium"
                    onClick={()=> setIsDeleting({status: true, plan: plan})}
                  >
                    <DeleteIcon className="my-auto mr-1 text-white" />
                    Delete Tier
                  </button>

                  <button 
                    className="flex flex-row bg-white text-primary-200 border-[1px] border-primary-200 rounded-md ml-auto my-auto mx-[24px] font-medium p-2"
                    onClick={()=> openEditPlanModal(plan)}
                  >
                    <EditIcon className="my-auto mr-1 text-primary-200" style={{height: 16, width: 16}} />
                    Edit Tier
                  </button>
                </div>
              </div>
            ))
          }
        </div>
        {
          ((isDeleting?.status && isDeleting?.plan?.plan_id) && <DeleteConfirmationModal dataName="membership tier" isOpen={isDeleting.status} data={{...isDeleting.plan, id: isDeleting.plan?.plan_id, item_name: isDeleting.plan?.plan_name}} handleDelete={handleDelete} closeDeleteModal={()=>setIsDeleting({status: false, plan: {} as PlanSchema})} />)
        }
      </>
    ) : (
      <div className="flex w-[423px] h-[350px] bg-white m-auto my-[48px] rounded-lg">
        <div className="flex flex-col m-auto w-9/12">
          <div className="flex mx-auto rounded-full h-[80px] w-[80px] bg-[#EFF8FA] mt-auto">
            <KitchenIcon className="m-auto text-primary-400 h-[40px] w-[40px]" />
          </div>
          <p className="font-semibold font-raleway text-[20px] text-primary-200 text-center mt-4">
            No Membership Tier Yet
          </p>
          <p className="text-[#333333] font-open-sans text-[16px] text-center my-3">
            Set up a membership tier to manage access to your community
          </p>
          <button 
            className="bg-primary-200 text-white w-full p-2 rounded-md my-2"
            onClick={openAddModal}
          >
            <AddCircle className="my-auto mx-2 text-white" style={{height: 24, width: 25}} />
            Add Membership Tier
          </button>
        </div>
      </div>
    )
  )
}




type CommunityRequirementsFormProps = {
  communityId: string
}

export const CommunityRequirementsForm: React.FC<CommunityRequirementsFormProps> = ({communityId}) => {

  const { requirements, isLoading, isLoadingRequirements, isError, addCommunityRequirements, addCustomRequirement, deleteResourceRequirement } = useLoadRequirements()
  const [selectedRequirements, setSelectedRequirements] = useState<RequirementSchema[]>(requirements || [])
  const [isAddingCustomRequirement, setIsAddingCustomRequirement] = useState<boolean>(false)
  const [isDeletingCustomRequirement, setIsDeletingCustomRequirement] = useState<{isOpen: boolean, req: RequirementSchema}>({isOpen: false, req: {}})
  // const [deleteReq, setDeleteReq] = useState<RequirementSchema>()
  const [expirationModal, setExpirationModal] = useState<{ open: boolean, reqCode?: string }>({ open: false });
  const [expirations, setExpirations] = useState<{ [code: string]: { type: string, value: number } }>({});

  // console.log("requirements", requirements)
  // console.log("selectedRequirements", selectedRequirements)

  // Check if item already exists in the array & add item if it doesn't exist
  const addSelection = (addedRequirement: RequirementsLookupSchema | RequirementSchema) => {
    const { requirementName, requirementCode } = addedRequirement as RequirementsLookupSchema;
    const exists = selectedRequirements.find((item: RequirementSchema) => item.name === requirementName);
    if (!exists) {
      // If an expiration exists for this code, set validity
      const exp = expirations[requirementCode];
      setSelectedRequirements([
        ...selectedRequirements,
        {
          name: requirementName,
          code: requirementCode,
          community_id: communityId,
          validity: exp ? `${exp.value} ${exp.type}` : undefined,
          // resource_id: resourceId ? resourceId : ""
        }
      ]);
    }
  };

  // Remove item by filtering out the item with the given name
  const removeSelection = (requirementName: string) => {
    setSelectedRequirements(selectedRequirements.filter((item: RequirementSchema) => item.name !== requirementName))
  };

  // const { addCommunityRequirements, isLoading, isError, isSuccess } = useResourceHook({});

  const handleAddRequirements = () => {
    if(selectedRequirements.length > 0){
      // Ensure validity is up to date with expirations before saving
      const updatedReqs = selectedRequirements.map(req => {
        const exp = expirations[req.code || ""];
        return exp ? { ...req, validity: `${exp.value} ${exp.type}` } : req;
      });
      addCommunityRequirements(updatedReqs);
    }
    if(isError) {
      toast.error("Error adding requirements. Please try again.");
    } else{
      toast.success("Requirements added successfully!");
    }
  }

  const handleAddCustomRequirement = (req: RequirementSchema) => {
    if(req?.name){
      addCustomRequirement(req)
    }
    if(isError){
      toast.error("Error adding custom requirement. Please try again.");
    } else{
      toast.success("Custom requirement added successfully!");
    }
  }

  const handleDeleteCustomRequirement = async (reqId: string) => {
    if (reqId){
      await deleteResourceRequirement(reqId)
    }
    setIsDeletingCustomRequirement({isOpen: false, req: {}})
  }

  // Handler to open modal
  // const handleOpenExpirationModal = (reqCode: string) => setExpirationModal({ open: true, reqCode });
  const handleCloseExpirationModal = () => setExpirationModal({ open: false });

  // Handler to set expiration
  const handleSetExpiration = (type: string, value: number) => {
    if (expirationModal.reqCode) {
      if (value > 0) {
        // Set expiration and validity
        setExpirations(prev => ({ ...prev, [expirationModal.reqCode!]: { type, value } }));
        setSelectedRequirements(prevReqs => prevReqs.map(req =>
          req.code === expirationModal.reqCode ? { ...req, validity: `${value} ${type}` } : req
        ));
        setExpirationModal({ open: false });
      } else {
        // Remove expiration and validity
        handleRemoveExpiration(expirationModal.reqCode)
        // setExpirations(prev => {
        //   const newExp = { ...prev };
        //   delete newExp[expirationModal.reqCode!];
        //   return newExp;
        // });
        // setSelectedRequirements(prevReqs => prevReqs.map(req =>
        //   req.code === expirationModal.reqCode ? { ...req, validity: undefined } : req
        // ));
        // setExpirationModal({ open: false });
      }
    }
  };

  // Handler to remove expiration/validity for a requirement
  const handleRemoveExpiration = (reqCode: string) => {
    // Update expirations state
    setExpirations(prev => {
      const newExp = { ...prev };
      delete newExp[reqCode];
      return newExp;
    });

    // Update selected requirements state
    setSelectedRequirements(prevReqs => {
      const updatedReqs = prevReqs.map(req =>
        req.code === reqCode ? { ...req, validity: undefined } : req
      );
      return updatedReqs;
    });

    // Update community requirements
    addCommunityRequirements(selectedRequirements.map(req =>
      req.code === reqCode ? { ...req, validity: undefined } : req
    ));

    setExpirationModal({ open: false });
  };

  useEffect(() => {
    document.title = "HomeCook | Community Requirements";
    setSelectedRequirements(requirements || [])
  }, [requirements]);

  useEffect(() => {
    // Load expirations from requirements and selectedRequirements
    const allReqs = [...(requirements || []), ...(selectedRequirements || [])];
    const newExpirations: { [code: string]: { type: string, value: number } } = {};
    allReqs.forEach(req => {
      if (req.code && req.validity) {
        // Parse validity string (e.g., '30 days', '2 years')
        const match = req.validity.match(/(\d+)\s*(days?|weeks?|months?|years?)/i);
        if (match) {
          newExpirations[req.code] = { value: parseInt(match[1], 10), type: match[2].toLowerCase() };
        }
      }
    });
    setExpirations(newExpirations);
    // eslint-disable-next-line
  }, [requirements, selectedRequirements]);

  // Helper to compare expirations
  const areExpirationsEqual = (a: typeof expirations, b: typeof expirations) => {
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    if (aKeys.length !== bKeys.length) return false;
    for (let key of aKeys) {
      if (!b[key] || a[key].type !== b[key].type || a[key].value !== b[key].value) return false;
    }
    return true;
  };

  // Compute baseExpirations for Save Changes logic
  const baseExpirations: typeof expirations = {};
  (requirements || []).forEach((req: RequirementSchema) => {
    if (req.code && req.validity) {
      const match = req.validity.match(/(\d+)\s*(days?|weeks?|months?|years?)/i);
      if (match) {
        baseExpirations[req.code] = { value: parseInt(match[1], 10), type: match[2].toLowerCase() };
      }
    }
  });
  const showSaveChanges =
    !areArraysEqualByProps(requirements, selectedRequirements, ['name']) ||
    !areExpirationsEqual(expirations, baseExpirations);

  const isRequirementsLoading = isLoading || isLoadingRequirements;

  if (isRequirementsLoading){
    return (
      <div className="w-full min-w-0 px-6 my-6">
        <LoadingScreen bgColor="white" height="h-auto" />
      </div>
    )
  }

  return (
    <>
      <div className="w-full min-w-0 px-6">
        <div data-testid="credential-requirements-card" className="flex flex-col w-full min-w-0 bg-white my-6 rounded-xl h-[777px] shadow-md overflow-hidden">
          <div className="flex flex-row w-full min-w-0 items-center justify-between gap-4 px-6 pt-6 pb-2">
            <p className="text-[#4D4D4D] text-[16px] font-open-sans flex-1 min-w-0">
              Choose requirements from the list below, or add your own.
            </p>
            {showSaveChanges ? (
              <button
                className="bg-white text-[16px] shrink-0 text-primary-200 h-[43px] px-3 border-[1px] border-[#E9E9E9] font-open-sans rounded-lg"
                onClick={handleAddRequirements}
              >
                Save Changes
              </button>
            ) : null}
          </div>

          <div className="flex flex-col flex-1 min-h-0 w-full overflow-y-auto px-6">
            {
              (requirementsLookUp && requirementsLookUp.length > 0) ? (
                requirementsLookUp.map((req, i: number)=> {
                  const isSelected = selectedRequirements && selectedRequirements.length > 0 && selectedRequirements.some((requirement: RequirementSchema) => requirement.code === req.requirementCode);
                  return isSelected ? (
                    <div
                      key={i}
                      className="flex flex-row bg-[#E6EBED] text-primary-200 text-[16px] font-open-sans rounded-md my-1 p-2 h-[59px] cursor-pointer items-center"
                      onClick={() => removeSelection(req.requirementName)}
                    >
                      <CheckBox className="mx-2 my-auto shrink-0" style={{height: 20, width: 20}} />
                      <p className="my-auto truncate">{req.requirementName}</p>
                      {expirations[req.requirementCode] && (
                        <span className="ml-2 text-xs text-primary-300 shrink-0">{expirations[req.requirementCode].value} {expirations[req.requirementCode].type}</span>
                      )}
                    </div>
                  ) : (
                    <div
                      key={i}
                      className="flex flex-row border-[1px] hover:bg-[#E9E9E9] border-[#E9E9E9] text-[16px] font-open-sans rounded-md my-1 p-2 h-[59px] cursor-pointer items-center"
                      onClick={() => addSelection(req)}
                    >
                      <CheckBoxOutlineBlank
                        className="mx-2 text-[#CFCFCF] my-auto shrink-0"
                        style={{height: 20, width: 20}}
                      />
                      <p className="my-auto truncate">{req.requirementName}</p>
                    </div>
                  )
                })
              ) : null
            }
            {
              (requirements || []).filter((reqmt: RequirementSchema) => !requirementsLookUp.some(selected => selected.requirementCode === reqmt.code)
              ).map((req: RequirementSchema, i: number) => (
              <div
                key={i}
                className="flex flex-row bg-[#E6EBED] text-primary-200 text-[16px] font-open-sans rounded-md my-1 p-2 h-[59px] cursor-pointer items-center"
              >
                  <CheckBox className="mx-2 my-auto shrink-0" style={{height: 20, width: 20}} />
                  <p className="my-auto truncate">{req.name}</p>
                  <div className="ml-auto cursor-pointer hover:text-slate-300 shrink-0">
                    <Delete onClick={()=> {
                      setIsDeletingCustomRequirement({isOpen: true, req: req})
                    }} style={{height: 20, width: 20}} />
                  </div>
              </div>
              ))
            }
          </div>
          <div className="px-6 pb-6 pt-2">
            <div
              onClick={()=>setIsAddingCustomRequirement(true)}
              className="flex flex-row items-center bg-[#F8F8F8] text-[16px] font-open-sans rounded-lg p-2 h-[59px] cursor-pointer"
            >
              <AddCircle className="my-auto mx-2 shrink-0" style={{height: 17, width: 17}} />
              <p className="my-auto text-[16px] font-open-sans text-black">Add Custom Requirement</p>
            </div>
          </div>
        </div>
      </div>
        <AddRequirementModal 
          isOpen={isAddingCustomRequirement} 
          closeAppModal={()=>setIsAddingCustomRequirement(false)} 
          handleAddCustomRequirement={handleAddCustomRequirement}
        />

        <DeleteConfirmationModal dataName="requirement" isOpen={isDeletingCustomRequirement.isOpen} data={{...isDeletingCustomRequirement.req, item_name: isDeletingCustomRequirement.req.name}} handleDelete={handleDeleteCustomRequirement} closeDeleteModal={()=>setIsDeletingCustomRequirement({isOpen: false, req: {}})} />
        
        <SetExpirationModal 
          isOpen={expirationModal.open} 
          closeAppModal={()=>handleCloseExpirationModal()} 
          handleSetExpiration={handleSetExpiration} 
          handleRemoveExpiration={() => expirationModal.reqCode && handleRemoveExpiration(expirationModal.reqCode)}
        />
        
        
      </>
    )
}


export default Memberships;
